export default "__VITE_ASSET__w_9e_KC3__"